// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.css'
})
export class AppFooterComponent {
  private destroyRef = inject(DestroyRef);

  currentYear = new Date().getFullYear();
  footerText: string | null = null;

  constructor(private configurationService: ConfigurationService) { }

  ngOnInit() {
    this.configurationService.getConfiguration().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((data: any) => {
      this.footerText = data.footerContent || null;
    });
  }
}
